module.exports = __webpack_public_path__ + "static/media/m2.4fd32721.jpg";